import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import spreadsheetValidation from './spreadsheetValidations'

export class CheckPreparationModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    // This is the validation if date is exceeded (Leap year is included)
    let invalid = this.props.grid
    const invalidData = invalid.filter(crf => {
      return (
        spreadsheetValidation.numbers(crf[5].value, crf[6].value) ||
        spreadsheetValidation.dates(crf[6].value, crf[5].value)
      )
    })
    const gridWithInput = this.props.grid.filter(
      crf =>
        crf[5].value.trim() !== '' &&
        crf[5].value.trim() !== 'CV #' &&
        crf[6].value !== '' &&
        crf[6].value !== 'CV Date'
    )

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Available</h4>
                        <h5 className='returnHeader'>
                          Are you sure you want to proceed? Please confirm.
                        </h5>
                      </>
                    ) : (
                      <h4 style={textRed}>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[1].value}</span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          spreadsheetValidation.numbers(crf[5].value)
                            ? textRed
                            : null
                        }
                      >
                        CV #:
                        {spreadsheetValidation.numbers(crf[5].value)
                          ? crf[5].value.trim() === ''
                            ? 'Empty'
                            : 'invalid'
                          : crf[5].value.trim()}
                      </span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          spreadsheetValidation.dates(crf[6].value)
                            ? textRed
                            : null
                        }
                      >
                        CV Date:
                        {crf[6].value === ''
                          ? 'Empty'
                          : spreadsheetValidation.dates(crf[6].value)
                          ? 'Invalid'
                          : crf[6].value.trim()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>CV number must be 9 numerical characters.</h6>
                      <h6>Date must be valid and in mm/dd/yyyy format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckPrepared}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default CheckPreparationModal
